import http from '@/services/http'
// import { formatErrors } from '@utils/errors-alert'

const resendInvite = async ({ commit }, id) => {
  return new Promise(async (resolve, reject) => {
    const response = http.post(`/contacts/${id}/send_welcome_email`)
    response.then((response) => {
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  })
}

const createContact = async ({ commit }, obj) => {
  return new Promise(async (resolve, reject) => {
    console.log(obj)
    const response = http.post(`/contacts/`, {contact: obj})
    response.then((response) => {
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  })
}

export default {
  resendInvite,
  createContact
}



// WEBPACK FOOTER //
// ./src/features/payer_contacts/store/actions.js